import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        loading: false,
        // baseurl: "https://temp-iee2020.pautacreativa.mx/admin/",
        // homeurl: "https://temp-iee2020.pautacreativa.mx/",
        baseurl: "https://www.iee.edu.mx/admin/",
        homeurl: "https://www.iee.edu.mx/",
        user: null,
        ciclo_escolar: null,
        ciclo_escolar_ano: null
    }
});